
<template>
    <figure class="hall-cover"
        :class="{
            [disabled ? 'disabled' : 'normal']: true, 
        }"
    >
        <q-img :src="oCurPics[`cover`]" alt="" /> 
        <!--
            ↑ 背景图 
            ↓ 内容 
        -->
        <div class="content"> 
            <h5 class="title">
                <img :src="oCurPics[`title`]" alt="" /> 
            </h5>
            <button class="fake-btn">
                <img :src="oCurPics['join']" alt="" /> 
            </button>
            <div class="info-box">
                <span class="access">
                    {{ $t('redPacketMines.access') }}
                    <CurrentCoin size="12px" class="inline-flex" />
                    <em>{{ info.min }}</em>
                </span>
                <span class="ante">
                    {{ $t('redPacketMines.ante')}}
                    <CurrentCoin size="12px" class="inline-flex" />
                    <em>{{ info.base }}</em>
                </span>
            </div>
        </div>
    </figure>
</template>

<script lang="ts" setup>
import { fnGetCoverPics } from '../ts/redPacketCommon'; 

const props = defineProps({
    hallNumber: {
        type: Number, 
        required: true, 
    },
    disabled: {
        type: Boolean,
    },
    info: {
        type: Object,
        default: () => ({}),
    },
});

const $i18n = useNuxtApp().$i18n;
const oPics = fnGetCoverPics();

const sLang = computed(()=>{
    return $i18n.locale.value;
});

const oCurPics = computed(()=>{
    const sNumber = `-0${props.hallNumber}`;
    const sJoin = `join-${sLang.value}`;
    const oResult = {
        join: oPics[sJoin],
    };
    Object.keys(oPics).forEach(key=>{
        const rightLang = (
            key.includes('title')
            ? key.includes(sLang.value)
            : true
        );
        if (key.includes(sNumber) && rightLang){ 
            const [shortKey] = key.split('-');
            oResult[shortKey] = oPics[key];
        }
    });
    return oResult; 
});


onMounted(()=>{
    // console.log('fnGetCoverPics\n', fnGetCoverPics());
    // console.log('oCurPics\n', deepCopy(oCurPics.value)); 
});


</script>

<style scoped lang="scss" >
.hall-cover{
    min-width: 90px; 
    min-height: 100px; 
    max-width: min(45vw, 200px); 
    position: relative; 
    font-size: 10px;
    transition: all 0.2s; 
    border-radius: 35px; 
    overflow: hidden; 
    border: 3px solid transparent;

    &.normal:active{
        transform: translateY(3px); 
    }
    &.normal:hover, 
    &.normal:active{
        border-color: #FFEDB5; 
    }
    &.disabled{
        opacity: 1 !important; 
        filter: brightness(0.5);
    }
}

@media screen and (max-width: 380px){
    .hall-cover{
        border-radius: 20px;
        font-size: 9px; 
    }
}

.content{
    position: absolute; 
    top: 0;
    bottom: 0;
    left: 0;
    right: 0; 
    // z-index: 0; 
    user-select: none; 
    text-align: center; 
    display: flex;
    flex-direction: column;
    color: white; 
    & > *{
        display: flex;
        justify-content: center; 
        align-items: center; 
        // box-shadow: 0px 0px 5px blue; 
        min-height: 5px; 
        text-align: center; 
        position: absolute; 
    }
    .title{
        top: 16%; 
        width: 100%;
        color: white; 
        img{
            margin: 0 auto; 
            max-width: 90%; 
        }
    }
    .fake-btn{
        top: 41%; 
        height: 24.5%;
        display: flex; 
        justify-content: center; 
        align-items: center; 
        width: 100%; 
        text-shadow: 1px 1px 1px rgb(0 0 0 / 0.5);
        img{
            max-width: 26%; 
        }
    }

    .info-box{
        bottom: 6%;
        left: 0;
        right: 0;
        width: 100%; 
        flex-direction: column; 
        display: flex; 
        justify-content: center; 
        span{
            border-radius: 200px;
            font-size: 0.9em; 
            padding: 1px 7px;  
            height: 14px;
            line-height: 14px; 
            background: rgba(17, 25, 35, 0.7);
            color: rgba(255, 197, 28, 1);
            display: flex;
            align-items: center;
            justify-content: center; 
            img{
                margin: 0 3px;
            }
            &.access{
                margin: 0 0 4px; 
            }
            &.ante{
                color: white; 
            }
            em{
                font-size: 1.3em;
                font-weight: bold;  
            }
        }
    }
}


</style>

